import { render, staticRenderFns } from "./PlanCompletedNotEnoughMoneyPopup.vue?vue&type=template&id=10dbc3ad&scoped=true"
import script from "./PlanCompletedNotEnoughMoneyPopup.vue?vue&type=script&lang=js"
export * from "./PlanCompletedNotEnoughMoneyPopup.vue?vue&type=script&lang=js"
import style0 from "./PlanCompletedNotEnoughMoneyPopup.vue?vue&type=style&index=0&id=10dbc3ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dbc3ad",
  null
  
)

export default component.exports